import {
  Button,
  DialogActions,
  DialogContent, DialogTitle, Divider, List, ListItem,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledDialog from './styles';

interface DisplayDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  commands: { commandName: string; card: string }[];
}

export default function DisplayDetailsDialog(props: DisplayDetailsDialogProps) {
  const { open, onClose, commands } = props;
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('session');

  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogTitle>
        {t('details.display.commands.title', { title: commands[0].card })}
      </DialogTitle>
      <DialogContent>
        <List>
          {commands.map((command) => (
            <>
              <ListItem key={command.commandName}>
                <ListItemText primary={command.commandName} />
              </ListItem>
              <Divider />
            </>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">{tCommon('close')}</Button>
      </DialogActions>
    </StyledDialog>
  );
}
